import { ArrowForwardIos, SystemUpdateAltSharp } from '@mui/icons-material'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'

import {
  ProductTreeItem,
  ProductTreeItemLabel,
  ProductTreeItemList,
} from '@/components/ProductDocuments/ProductDocuments.styled'

import type React from 'react'
import type { ProductDocument } from '@/gen/ecom'

interface ProductDocumentsProps {
  name?: string
  productDocument: ProductDocument | ProductDocument[]
}
export const ProductDocuments: React.FC<ProductDocumentsProps> = ({ name, productDocument }) => {
  const treeLine = Array.isArray(productDocument)

  return (
    <>
      <SimpleTreeView>
        {!treeLine ? (
          <ProductTreeItem
            itemId="grid"
            label={
              <ProductTreeItemLabel target="_blank" href={productDocument.url ?? '#'}>
                <SystemUpdateAltSharp sx={{ color: 'text.primary', marginRight: 1.5 }} fontSize="medium" /> {name}
              </ProductTreeItemLabel>
            }
          />
        ) : (
          <ProductTreeItem
            itemId="charts"
            label={
              <ProductTreeItemList>
                <ArrowForwardIos sx={{ color: 'text.primary', marginRight: 1.5 }} fontSize="medium" /> {name}
              </ProductTreeItemList>
            }
          >
            {productDocument.map((document, index) => (
              <ProductTreeItem
                sx={{ paddingLeft: 3 }}
                key={`${document}__${index + 1}`}
                itemId={`${document}__${index + 1}`}
                label={
                  <ProductTreeItemLabel target="_blank" href={document?.url ?? '#'}>
                    <SystemUpdateAltSharp sx={{ color: 'text.primary', marginRight: 1.5 }} fontSize="medium" />
                    {`${name}  ${index + 1}`}
                  </ProductTreeItemLabel>
                }
              />
            ))}
          </ProductTreeItem>
        )}
      </SimpleTreeView>
    </>
  )
}
